import React from 'react'
import MetaData from '../components/MetaData'
import { useGuide } from '../api'

import {
  PLACE_DESCRIPTION
} from '../trans'


const PlaceMetaData = (props) => {
  const {place} = props
  const guide = useGuide()
  if (!place || !guide) return null

  const title = `${place.title} ${place.subtitle}`
  const description = PLACE_DESCRIPTION({
    place_type: place.subtitle, 
    place_name : place.title,
    route_title: guide.title
  })

  jsonLd = {
    "@context": "https://schema.org",
    "@type": "Place",
    "name": place.title,
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": place.lnglat[1],
      "longitude": place.lnglat[0]
    }
  }

  if (place.description){
    jsonLd['description'] = place.description.replace(/(<([^>]+)>)/gi, "")
  }

  return <MetaData title={title} 
                   description={description} 
                   shareImageTitle={place.title}
                   jsonLd={jsonLd} />

}

export default PlaceMetaData;
